import React, { useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import './ToolPage.css'
import './PlanningPoker.css'
import { createPlanningPokerRoom } from './utils/planningPokerApiClient'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const DECKS = [
  { key: 'fibonacci', label: 'Fibonacci (estimativa)', preview: '0, 1, 2, 3, 5, 8, 13, 21, 34, ?, ☕' },
  { key: 'tshirt', label: 'Camisetas (P/M/G)', preview: 'PP, P, M, G, GG, ?' },
  { key: 'confidence', label: 'Confiança (1 a 5)', preview: '1, 2, 3, 4, 5' },
]

const PlanningPokerCreate = () => {
  useDocumentMeta({
    title: 'Planning Poker Online | jarder.dev',
    description:
      'Sala de estimativa em grupo: todo mundo vota ao mesmo tempo e os ' +
      'votos só aparecem depois que todos revelam juntos. Serve pra ' +
      'estimar tarefas ou pra qualquer decisão em grupo. Grátis, sem cadastro.',
  })

  const history = useHistory()
  const [deck, setDeck] = useState('fibonacci')
  const [status, setStatus] = useState('idle')
  const [error, setError] = useState('')

  const create = async () => {
    setStatus('loading')
    setError('')
    try {
      const { id, masterToken } = await createPlanningPokerRoom(deck)
      trackEvent('tool_generate', { tool: 'planning_poker', deck })
      history.push(`/ferramentas/planning-poker/${id}/mestre#token=${masterToken}`)
    } catch {
      setError('Não foi possível criar a sala agora. Tente novamente.')
      setStatus('idle')
    }
  }

  return (
    <div className="tool-page">
      <Link to="/ferramentas" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>Planning Poker</h1>
      <p className="tool-disclaimer">
        Cada participante entra pelo link e escolhe uma carta em segredo.
        Ninguém vê o voto de ninguém (nem você, o mestre) até clicar em
        revelar, aí todos aparecem juntos. Serve pra estimar tarefas de
        time ou qualquer decisão em grupo que precise de voto sem
        influência.
      </p>

      <fieldset className="tool-field poker-deck-field">
        <legend>Qual baralho usar?</legend>
        <div className="poker-deck-options">
          {DECKS.map((option) => (
            <label key={option.key} className="poker-deck-option">
              <input
                type="radio"
                name="deck"
                checked={deck === option.key}
                onChange={() => setDeck(option.key)}
              />
              <span>
                <strong>{option.label}</strong>
                <span className="poker-deck-preview">{option.preview}</span>
              </span>
            </label>
          ))}
        </div>
      </fieldset>

      <button type="button" className="tool-button" onClick={create} disabled={status === 'loading'}>
        {status === 'loading' ? 'Criando sala...' : 'Criar sala'}
      </button>

      {error && <p className="tool-error">{error}</p>}

      <div className="tool-info-section">
        <h2>Como funciona</h2>
        <p>
          Ao criar, você vai pra tela de mestre, só você tem acesso a
          ela. Lá tem um link separado pra compartilhar com os
          participantes.
        </p>
        <p>
          Você define o tópico sendo votado (opcional), acompanha quem já
          votou (sem ver o valor) e clica em "Revelar" quando todos
          tiverem votado. Depois disso, dá pra iniciar uma nova rodada
          pro próximo item.
        </p>
      </div>
    </div>
  )
}

export default PlanningPokerCreate
